// extracted by mini-css-extract-plugin
export default {"box":"ShopCard_box__YipLw","boxPrice":"ShopCard_boxPrice__JNoO0","title":"ShopCard_title__7byLq","btn":"ShopCard_btn__ZQPXC"};